import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { RecordSgm } from '../data';
import { v4 as uuidv4 } from 'uuid';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SgmService } from '../../../../services/sgm/sgm.service';

import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { NbDialogService } from '@nebular/theme';
import { AuthorizationService } from '../../../../services/authorization.service';
import { UsersSgmSasisopaFormComponent } from '../users-sgm-sasisopa-form/users-sgm-sasisopa-form.component';

type Row = {
  id: string;
  date: string | Date;
  no: string;
  name_of_report: string;
  responsable: string;
  area: string;
  description: string;
  affect_sgm: boolean;
  no_affect: boolean;
  with_op_sgm: boolean;
  suggestion: boolean;
  real: boolean;
  potential: boolean;
  better: boolean;
  no_apply: boolean;

  reasons: { reason: string; }[];
  corrections: { correction: string; responsable: string; date: string | Date; }[];
  actions: { action: string; result: string; responsable: string; date: string | Date; }[];
  authorized: { id: string; name: string, signature: string }

}

const emptyForm: Row = {
  id: '',
  date: '',
  no: '',
  name_of_report: '',
  area: '',
  description: '',
  responsable: '',
  affect_sgm: false,
  no_affect: false,
  with_op_sgm: false,
  suggestion: false,
  real: false,
  potential: false,
  better: false,
  no_apply: false,
  reasons: [],
  corrections: [],
  actions: [],
  authorized: { id: '', name: '', signature: '' }
}

@Component({
  selector: 'ngx-sgm-formato-trece',
  templateUrl: './formato-trece.component.html'
})
export class FormatoTreceComponent implements OnInit {
  @Input() stationId: string;
  @Input() record: RecordSgm;
  @Output() recordChange = new EventEmitter<Partial<RecordSgm & { row: any, event: string }> >();
  source: LocalDataSource;
  row = { ...emptyForm }
  authorizations = [];
  loading = false
  settings = {
    actions: {
      columnTitle: 'Acciones',
      position: 'right',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name_of_report: {
        title: 'Persona o entidad que reporta el hallazgo',
        filter: true,
      },
      area: {
        title: 'Área en la que detecta el hallazgo',
        filter: true,
      },
      date: {
        title: 'Fecha',
        filter: true,
        valuePrepareFunction: (date) => moment(date).format('DD-MM-YYYY')
      },
      description: {
        title: 'Descripción del hallazgo detectado',
        filter: true,
      },
    },
    noDataMessage: 'Sin registros',
  };

  constructor(
    private sgmService: SgmService,
    private dialogService: NbDialogService,
    private authorizationService: AuthorizationService,
  ) {}

  ngOnInit() {
    this.loadData()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.record.currentValue.rows) {
      this.source = new LocalDataSource(changes.record.currentValue.rows)
    }
  }

  async onCustom(event: { action: string; data: Row; }) {
    this.row = event.data;
    if (event.action === 'delete') {
      // @ts-ignore
      $('#delete-document').modal('show');
    } else if (event.action === 'edit') {
      if (!this.row.authorized) {
        this.row.authorized = { id: '', name: '', signature: '' }
      }
      // @ts-ignore
      $('#create-document').modal('show');
    } else if (event.action === 'download') {
      this.download();
    }
  }

  async remove () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: 'delete' })
    this.record.rows = this.record.rows.filter(row => row.id !== this.row.id)
    this.loadData()
    // @ts-ignore
    $('#delete-document').modal('hide');
  }

  async storeOrUpdate () {
    this.recordChange.emit({ ...this.record, rows: [], row: this.row, event: this.row.id ? 'edit' : 'create' })
    this.loadData()
    // @ts-ignore
    $('#create-document').modal('hide');
  }

  loadData () {
    this.row = { ...emptyForm };
    this.source = new LocalDataSource(this.record.rows)
    this.getAuthorizations();
  }

  async getAuthorizations() {
    this.loading = true;
    const [err, response]: any = await this.authorizationService.indexSGM(this.stationId);
    this.loading = false;
    if (err) return this.alert('Oops,', 'error', 'Intenta más tarde [Error. Lista de Autorizados]');
    this.authorizations = response.data;
  }

  openNewEmployee() {
    this.dialogService.open(UsersSgmSasisopaFormComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(employeeStored => employeeStored ? this.getAuthorizations() : null);
  }

  changeAuthorization (id: string) {
    console.log('🚀 ~ FormatoCincoComponent ~ changeAuthorization ~ id:', id)
    const findAuth = this.authorizations.find(authorized => authorized.id === id)
    if (findAuth) {
      this.row.authorized.name = findAuth.name
      this.row.authorized.signature = findAuth.signature
    }
  }

  addReason () {
    this.row.reasons.push({ reason: '' })
  }

  addCorrection () {
    this.row.corrections.push({ correction: '', responsable: '', date: '' })
  }

  addAction () {
    this.row.actions.push({ responsable: '', result: '', action: '', date: '' })
  }

  removeToArray (index: number, rows: Array<any>) {
    rows.splice(index, 1)
  }

  async download () {
    await this.sgmService.downloadFormat({
      stationId: this.stationId,
      category: this.record.category,
      file: this.record.key,
      id_item: this.row.id
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
